import React, { type ComponentPropsWithoutRef, useRef } from 'react';

import { useHostChromeVars } from './hooks/useHostChromeVars';

/**
 * The scroll container a page MFE mounts in, publishing its insets as the host chrome variables
 * while mounted. Each layout renders its own, so the measurement starts and stops with that
 * layout. It is the scroll container rather than `main` because the help drawer's margin sits on
 * it, so a slideout stops short of the open drawer.
 */
export const HostChromePageArea = (props: ComponentPropsWithoutRef<'div'>) => {
  const pageAreaRef = useRef<HTMLDivElement>(null);
  useHostChromeVars(pageAreaRef);
  return <div ref={pageAreaRef} {...props} />;
};
